import { useAuth } from '../utils/auth/AuthProvider';

const useIsAdmin = () => {
    const { user } = useAuth(); // Use the context to get the user object
    const isAdmin = user?.UserRole === 'Admin';
    return isAdmin;
};

export default useIsAdmin;
